/* istanbul ignore file */
/**
 * Toggle Switch component theme configuration.
 */

export const toggleSwitchComponentConfig = {
  toggleswitch: {
    root: {
      width: '32px',
      height: '16px',
      borderRadius: '8px',
      gap: '2px',
      shadow: '{form.field.shadow}',
      focusRing: {
        width: '{focus.ring.width}',
        style: '{focus.ring.style}',
        color: '{focus.ring.color}',
        offset: '{focus.ring.offset}',
        shadow: '{focus.ring.shadow}',
      },
      borderWidth: '0',
      borderColor: '#ffffff',
      hoverBorderColor: '#ffffff',
      checkedBorderColor: '{primary.color}',
      checkedHoverBorderColor: '{primary.color}',
      invalidBorderColor: '{form.field.invalid.border.color}',
      background: '{greymatter.400}',
      hoverBackground: '{greymatter.600}',
      checkedBackground: '{primary.color}',
      checkedHoverBackground: '{primary.color}',
      transitionDuration: '{form.field.transition.duration}',
      slideDuration: '0.1s',
      disabledBackground: '{greymatter.150}',
    },
    handle: {
      borderRadius: '50%',
      size: '12px',
      background: '#ffffff',
      hoverBackground: '#ffffff',
      checkedBackground: '{primary.contrast.color}',
      checkedHoverBackground: '{primary.contrast.color}',
      disabledBackground: '#ffffff',
      color: '{surface.0}',
      hoverColor: '{surface.0}',
      checkedColor: '{primary.color}',
      checkedHoverColor: '{primary.color}',
    },
  },
};
